import Head from 'next/head';
import styles from './TOSLayout.module.scss';

const TOSLayout = ({children, title, headerInfo}) => {
    return (
        <>
            <Head>
                <title>{title} | afterglow</title>
            </Head>
            <div className={styles.TOSLayout}>
                <header>
                    <h1>{title}</h1>
                    <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginBottom: "32px"}}>
                        <p><strong>xoafterglow.com</strong></p>
                        <p><strong>{headerInfo.documentDetail}</strong></p>
                        <p><strong>Last Updated: {headerInfo.lastUpdated}</strong></p>
                    </div>
                </header>
                <main>
                    {children}
                </main>
            </div>
        </>
    )
}


export default TOSLayout;